import { Property } from '@sales-app/api/GeoLocation/GeoLocation'

import { LatLng, LatLngBounds, SearchMapSize, SearchMapState } from './searchMap.types'

export const SearchMapActionTypes: { [key: string]: string } = {
  setView: 'SEARCHMAP_setView',
  setZoom: ' SEARCHMAP_setZoom',
  setCenter: 'SEARCHMAP_setCenter',
  setBounds: 'SEARCHMAP_setBounds',
  setPoints: 'SEARCHMAP_setPoints',
  setSize: 'SEARCHMAP_setSize',
  hydrate: 'SEARCHMAP_hydrate',
  openPopup: 'SEARCHMAP_openPopup',
  closePopup: 'SEARCHMAP_closePopup',
  setShow: 'SEARCHMAP_setShow',
  setIsLoading: 'SEARCHMAP_setIsLoading',
}

interface SetViewParams {
  bounds: LatLngBounds
  center: LatLng
  size?: SearchMapSize
  zoom: number
}

export const SearchMapActions = {
  //super action for setting all view params
  setView: ({ bounds, center, size, zoom }: SetViewParams): { payload: SetViewParams; type: string } => {
    return {
      type: SearchMapActionTypes.setView,
      payload: {
        zoom,
        center,
        bounds,
        ...(size && { size }),
      },
    }
  },
  setZoom: (zoom: number): { type: string; zoom: number } => {
    return { type: SearchMapActionTypes.setZoom, zoom }
  },
  setCenter: (latlng: LatLng): { pos: LatLng; type: string } => {
    return { type: SearchMapActionTypes.setCenter, pos: latlng }
  },
  setPoints: (payload: Property[]): { payload: Property[]; type: string } => {
    return { type: SearchMapActionTypes.setPoints, payload }
  },
  setBounds: (bounds: LatLngBounds): { bounds: LatLngBounds; type: string } => {
    return { type: SearchMapActionTypes.setBounds, bounds }
  },
  setSize: (size: SearchMapSize): { size: SearchMapSize; type: string } => {
    return { type: SearchMapActionTypes.setSize, size }
  },
  openPopup: (payload: Property): { payload: Property; type: string } => {
    return { type: SearchMapActionTypes.openPopup, payload }
  },
  closePopup: (): { type: string } => {
    return { type: SearchMapActionTypes.closePopup }
  },
  setIsMouseOverPopup: (isMouseOverPopup: boolean): { payload: boolean; type: string } => {
    return { type: SearchMapActionTypes.isMouseOverPopup, payload: isMouseOverPopup }
  },
  setShow: (payload?: boolean): { payload?: boolean; type: string } => {
    return { type: SearchMapActionTypes.setShow, payload }
  },
  setIsLoading: (payload?: boolean): { payload?: boolean; type: string } => {
    return { type: SearchMapActionTypes.setIsLoading, payload }
  },
  hydrate: (payload: SearchMapState): { payload: SearchMapState; type: string } => {
    return { type: SearchMapActionTypes.hydrate, payload }
  },
}
